import styles from "./DropDownMenu.module.css";
import Icon from "@mdi/react";
import { mdiChevronUp, mdiChevronDown } from "@mdi/js";

// React
import React, { useState, useEffect } from "react";
import Foco from "react-foco";

export class dropDownOptions {
	constructor(icon, label, color, id) {
		this.icon = icon;
		this.label = label;
		this.color = color;
		this.id = id;
	}
}

export default function DropDownMenu(props) {
	const [showItems, setShowItems] = useState(false);
	const [selectedItem, setSelectedItem] = useState(props.selectedItem);

	// When the prop change the state change on the fly
	useEffect(() => {
		setSelectedItem(props.selectedItem);
	}, [props.selectedItem]);

	// handles
	const handleDropDown = () => {
		setShowItems(!showItems);
	};

	const handleSelectItem = (itemMenuSelected) => {
		setShowItems(false);
		setSelectedItem(itemMenuSelected);

		// Pass to parent the item and the type of dropdown
		props.onSelect(itemMenuSelected, props.type);
	};

	const upArrow = <Icon path={mdiChevronUp} size={1.1} />;
	const downArrow = <Icon path={mdiChevronDown} size={1.1} />;

	// <Foco/> -> external library, is a wraper to get the event 'click out of component'
	return (
		<Foco
			onClickOutside={() => {
				setShowItems(() => false);
			}}
		>
			<div style={props.width}>
				{/* <div> */}
				{/* If the dropdown has color add it to the base style */}
				<div className={[styles.selectBox, styles[selectedItem.color]].join(" ")} onClick={handleDropDown}>
					{selectedItem.icon}
					{props.selectedItemWithLabel ? <p>&nbsp;{selectedItem.label}</p> : ""}
					{showItems ? upArrow : downArrow}
				</div>
				{showItems && (
					<div className={styles.wrapper}>
						<div className={styles.displayItems}>
							{props.items.map((item) => (
								<div
									className={[styles.listItems, styles[item.color]].join(" ")}
									key={item.id}
									onClick={() => handleSelectItem(item)}
								>
									<div
										className={[
											styles.item,
											item.id == selectedItem.id ? styles.selectedItem : "",
										].join(" ")}
									>
										{item.icon}
										{item.label}
									</div>
								</div>
							))}
						</div>
					</div>
				)}
			</div>
		</Foco>
	);
}
